import tippy from 'tippy.js';
import { Slider } from './slider';
import { Calculator } from './calculator';
import { PriceManager } from './priceManager';

const matarialCountInput = document.getElementById('matarialCountInput') as HTMLInputElement;
const downloadsCountInput = document.getElementById('downloadsCountInput') as HTMLInputElement;

const matarialCountSlider = new Slider({
  container: document.getElementById('matarialCountContainer'),
  input: matarialCountInput,
  toggler: document.getElementById('matarialCountToggler'),
  whiteLine: document.getElementById('matarialCountWhiteLine'),
  min: 0,
  max: 100,
  initValue: 14,
});

const downloadsCountSlider = new Slider({
  container: document.getElementById('downloadsCountContainer'),
  input: downloadsCountInput,
  toggler: document.getElementById('downloadsCountToggler'),
  whiteLine: document.getElementById('downloadsCountWhiteLine'),
  min: 0,
  max: 100,
  initValue: 40,
});

const priceManager = new PriceManager();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const calculator = new Calculator(
  matarialCountSlider,
  downloadsCountSlider,
  priceManager,
  document.getElementById('calc_result'),
);

tippy('#cls-tooltip', {
  content: 'Мы&nbsp;рекомендуем указывать <strong>минимально возможную</strong> цену за&nbsp;материал, чтобы сделать материал доступным для покупки большему числу педагогов. Это позволит увеличить количество продаж и&nbsp;Ваш суммарный доход!',
  allowHTML: true,
});
